"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * oai-api
 * The OptionsAI API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: tech@options.ai
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
const _1 = require("./");
function TargetFromJSON(json) {
    return TargetFromJSONTyped(json, false);
}
exports.TargetFromJSON = TargetFromJSON;
function TargetFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': json['id'],
        'date': (json['date']),
        'price': json['price'],
        'symbol': json['symbol'],
        'moveZone': _1.MoveZoneFromJSON(json['moveZone']),
        'setAt': (json['setAt']),
        'targetType': _1.TargetTypeFromJSON(json['targetType']),
    };
}
exports.TargetFromJSONTyped = TargetFromJSONTyped;
function TargetToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'date': (value.date),
        'price': value.price,
        'symbol': value.symbol,
        'moveZone': _1.MoveZoneToJSON(value.moveZone),
        'setAt': (value.setAt),
        'targetType': _1.TargetTypeToJSON(value.targetType),
    };
}
exports.TargetToJSON = TargetToJSON;
